var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutcome3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F43E3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1049_108196",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1049_108196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 13C25.45 13 24.9792 12.8042 24.5875 12.4125C24.1958 12.0208 24 11.55 24 11C24 10.45 24.1958 9.97917 24.5875 9.5875C24.9792 9.19583 25.45 9 26 9C26.55 9 27.0208 9.19583 27.4125 9.5875C27.8042 9.97917 28 10.45 28 11C28 11.55 27.8042 12.0208 27.4125 12.4125C27.0208 12.8042 26.55 13 26 13ZM25 29V21C25 20.3333 24.8292 19.7333 24.4875 19.2C24.1458 18.6667 23.7083 18.25 23.175 17.95L24.05 15.375C24.1833 14.9583 24.4292 14.625 24.7875 14.375C25.1458 14.125 25.55 14 26 14C26.45 14 26.8542 14.125 27.2125 14.375C27.5708 14.625 27.8167 14.9583 27.95 15.375L30.5 23H28V29H25ZM20.5 18.5C20.0833 18.5 19.7292 18.3542 19.4375 18.0625C19.1458 17.7708 19 17.4167 19 17C19 16.5833 19.1458 16.2292 19.4375 15.9375C19.7292 15.6458 20.0833 15.5 20.5 15.5C20.9167 15.5 21.2708 15.6458 21.5625 15.9375C21.8542 16.2292 22 16.5833 22 17C22 17.4167 21.8542 17.7708 21.5625 18.0625C21.2708 18.3542 20.9167 18.5 20.5 18.5ZM13.5 13C12.95 13 12.4792 12.8042 12.0875 12.4125C11.6958 12.0208 11.5 11.55 11.5 11C11.5 10.45 11.6958 9.97917 12.0875 9.5875C12.4792 9.19583 12.95 9 13.5 9C14.05 9 14.5208 9.19583 14.9125 9.5875C15.3042 9.97917 15.5 10.45 15.5 11C15.5 11.55 15.3042 12.0208 14.9125 12.4125C14.5208 12.8042 14.05 13 13.5 13ZM11.5 29V22H10V16C10 15.45 10.1958 14.9792 10.5875 14.5875C10.9792 14.1958 11.45 14 12 14H15C15.55 14 16.0208 14.1958 16.4125 14.5875C16.8042 14.9792 17 15.45 17 16V22H15.5V29H11.5ZM19 29V25H18V21C18 20.5833 18.1458 20.2292 18.4375 19.9375C18.7292 19.6458 19.0833 19.5 19.5 19.5H21.5C21.9167 19.5 22.2708 19.6458 22.5625 19.9375C22.8542 20.2292 23 20.5833 23 21V25H22V29H19Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcome3);
export default __webpack_public_path__ + "static/media/outcome3.bcbf9b9daf4a4b944d5d4f5762cadc59.svg";
export { ForwardRef as ReactComponent };